module.exports = __webpack_public_path__ + "img/liangtang-back-one.07124513.png";